export const MEMBERS = [
    {
        id: 0,
        name: "Lorem ipsum",
        title: "Executive Director"
    },
    {
        id: 1,
        name: "Lorem ipsum",
        title: "Administrative Operations Manager"
    },
    {
        id: 2,
        name: "Lorem ipsum",
        title: "Logistics & Transportation"
    },
    {
        id: 3,
        name: "Lorem ipsum",
        title: "Food Drive Administrator"
    },
    {
        id: 4,
        name: "Lorem ipsum",
        title: "Fundraising"
    },
    {
        id: 5,
        name: "Lorem ipsum",
        title: "Marketing & Public Relations"
    },
    {
        id: 6,
        name: "Lorem ipsum",
        title: "Hero Partnerships"
    },
    {
        id: 7,
        name: "Lorem ipsum",
        title: "Volunteer Management"
    },
    {   id: 8,
        name: "Lorem ipsum",
        title: "Volunteer Coordinator"
    },
    {
        id: 9,
        name: "Lorem ipsum",
        title: "Progams & Events"
    }
];